(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6765],{

/***/ 7027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Basket; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(9363);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2186);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(6843);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(8943);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(8867);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(8271);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1051);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(5659);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7039);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var router = __webpack_require__(6971);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/io/index.mjs
var io = __webpack_require__(4869);
// EXTERNAL MODULE: ./services/frontend/CartStorage.js + 2 modules
var CartStorage = __webpack_require__(9150);
// EXTERNAL MODULE: ./services/frontend/pricing.service.js
var pricing_service = __webpack_require__(5049);
// EXTERNAL MODULE: ./services/helper.js + 23 modules
var helper = __webpack_require__(3236);
// EXTERNAL MODULE: ./utils/analytics.js
var analytics = __webpack_require__(7991);
// EXTERNAL MODULE: ./utils/analyticsConfig.js
var analyticsConfig = __webpack_require__(7981);
// EXTERNAL MODULE: ./components/Loader.jsx
var Loader = __webpack_require__(4834);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/image.js
var next_image = __webpack_require__(1968);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/go/index.mjs
var go = __webpack_require__(5633);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-icons@5.7.0_react@18.3.1/node_modules/react-icons/tb/index.mjs
var tb = __webpack_require__(7527);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(8071);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1008);
// EXTERNAL MODULE: ./lib/utils.js
var utils = __webpack_require__(5551);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(473);
// EXTERNAL MODULE: ./components/utils/fileutil.js
var fileutil = __webpack_require__(9071);
// EXTERNAL MODULE: ./components/Cart/bag-item.module.css
var bag_item_module = __webpack_require__(1257);
var bag_item_module_default = /*#__PURE__*/__webpack_require__.n(bag_item_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/Cart/BagItem.js














var BagItem = function BagItem(_ref) {
  var item = _ref.item,
      removeProductFromCart = _ref.removeProductFromCart,
      updateProductCount = _ref.updateProductCount;

  var _useState = (0,react.useState)(item.quantity || 1),
      count = _useState[0],
      setCount = _useState[1];

  var _useState2 = (0,react.useState)(0),
      availableStock = _useState2[0],
      setAvailableStock = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      mounted = _useState3[0],
      setMounted = _useState3[1];

  var availableProductQuantity = item !== null && item !== void 0 && item.productCount ? parseInt(item === null || item === void 0 ? void 0 : item.productCount) : Number.MAX_SAFE_INTEGER;
  var isProductCustomised = item.customAttributes.length > 0;
  (0,react.useEffect)(function () {
    setMounted(true);
  }, []);
  (0,react.useEffect)(function () {
    updateProductCount(item.id, item.size, count);

    if (item.size) {
      var stock = findProductStockAndPrice(item.size, item);
      setAvailableStock(stock && stock.stockAvailable ? stock.stockAvailable : 0);
    } else {
      setAvailableStock(item.availableStock);
    }
  }, [count]);
  (0,react.useEffect)(function () {
    var _item$fields, _item$fields$OtherPh;

    if (mounted && item !== null && item !== void 0 && (_item$fields = item.fields) !== null && _item$fields !== void 0 && (_item$fields$OtherPh = _item$fields["Other photos"]) !== null && _item$fields$OtherPh !== void 0 && _item$fields$OtherPh.length) {
      localStorage.clear();
      window.location.reload();
    }
  }, [mounted, item]);

  var findProductStockAndPrice = function findProductStockAndPrice(size, product) {
    if (!size) {
      size = "-";
    }

    var variantPrice = product.variantOptions;
    var variantObj = {};

    if (!variantPrice || variantPrice && !variantPrice.length) {
      return product.price;
    }

    variantPrice.forEach(function (variant) {
      var vSize = variant && variant.type === "fit" ? variant === null || variant === void 0 ? void 0 : variant.name : "-";

      if (!variantObj[vSize]) {
        variantObj[vSize] = {
          price: variant === null || variant === void 0 ? void 0 : variant.price,
          stockAvailable: variant === null || variant === void 0 ? void 0 : variant.availableStock
        };
      }
    });
    return variantObj[size];
  };

  var originalPhoto = item === null || item === void 0 ? void 0 : item.productPhotos[0];
  var urlPath = originalPhoto ? new URL(originalPhoto).pathname : "";
  var extractedImageName = (0,fileutil/* parseFileName */.x)(urlPath).name;
  var newPhoto = originalPhoto !== null && originalPhoto !== void 0 && originalPhoto.includes("dm2buy") ? "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(extractedImageName, ".jpg?quality=50") : (0,cdn/* toCdnUrl */.V$)(originalPhoto);
  var fallBackPhoto = originalPhoto;
  var resolved = (0,media/* resolveImage */.rs)(originalPhoto, item === null || item === void 0 ? void 0 : item.productPhotosV2, "cart");

  if (!mounted) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (bag_item_module_default()).orderItem,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (bag_item_module_default()).productDetails,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (bag_item_module_default()).thumbnailContainer,
        children: [resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
          resolved: resolved,
          alt: "Order name",
          width: 60,
          height: 60,
          imgClassName: (bag_item_module_default()).orderThumbnail
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: newPhoto,
          unoptimized: true,
          height: 60,
          width: 60,
          alt: "Order name",
          className: (bag_item_module_default()).orderThumbnail,
          onError: function onError(e) {
            e.target.src = fallBackPhoto;
          }
        }), item.colour ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (bag_item_module_default()).productColor,
          style: {
            backgroundColor: item.colour
          }
        }) : null]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (bag_item_module_default()).productName,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: item.name
        }), isProductCustomised && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (bag_item_module_default()).product_specs,
          children: item.customAttributes.map(function (ca) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              children: [ca.name, " - ", ca.value + ""]
            }, "".concat(ca.name, "-").concat(ca.value));
          }).reduce(function (prev, curr) {
            return [prev, ", ", curr];
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (bag_item_module_default()).product_specs,
          children: item.size ? "Variant - " + item.size : ""
        }), availableProductQuantity > 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (bag_item_module_default()).quantityControls,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "rounded-full p-2",
            onClick: function onClick() {
              if (count < 2) return;
              setCount(count - 1);
            },
            "aria-label": "Decrement quantity",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(tb/* TbMinus */.ffR, {
              size: 20,
              className: "text-fontBackground"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: count
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "rounded-full p-2",
            onClick: function onClick() {
              if (count < availableStock) {
                setCount(count + 1);
              }
            },
            "aria-label": "Increment quantity",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(go/* GoPlus */.ueT, {
              size: 20,
              className: "text-fontBackground"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (bag_item_module_default()).details_right,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (0,utils.cn)((bag_item_module_default()).productPrice, "!text-fontBackground"),
        children: "".concat(String.fromCharCode(0x20b9)).concat(count * item.price)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        onClick: removeProductFromCart(item.id),
        className: "rounded-full p-2",
        "aria-label": "Remove product from cart",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoMdClose */.QAE, {
          size: 20,
          className: "text-fontBackground"
        })
      })]
    })]
  });
};

/* harmony default export */ var Cart_BagItem = (BagItem);
;// CONCATENATED MODULE: ./components/Cart/Basket.jsx









var _excluded = ["store"];


function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }














var Basket = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Basket, _React$Component);

  var _super = _createSuper(Basket);

  function Basket(props) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, Basket);

    _this = _super.call(this, props);

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "handleWindowResize", function () {
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", "".concat(vh, "px"));
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "removeProductFromCart", function (productId) {
      return function () {
        var cartData = _this.props.cartData;
        var filteredProducts = cartData.products.filter(function (product) {
          return product.id !== productId;
        });

        if (filteredProducts.length === 0) {
          _this.props.handleShowCart(false);

          if (!_this.props.fromProductPage) _this.props.setRefresh();

          if (_this.props.setHideInAdvance) {
            _this.props.setHideInAdvance(true);
          }
        }

        var timerId = setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  cartData.products = filteredProducts;
                  _context.next = 3;
                  return CartStorage/* default.saveCart */.Z.saveCart(cartData);

                case 3:
                  if (_this.props.fromProductPage) {
                    _this.props.setCart(cartData, true);
                  } else {
                    _this.props.setCart(cartData);
                  }

                  _this.setState({
                    refresh: !_this.state.refresh
                  });

                  if (_this.props.updateAddedToCart) {
                    _this.props.updateAddedToCart(productId, false);
                  }

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })), 300);
        _this.removeTimer = timerId;
      };
    });

    (0,defineProperty["default"])((0,assertThisInitialized/* default */.Z)(_this), "updateProductCount", /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(productId, variant, count) {
        var cartData, productIndex;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cartData = _this.props.cartData;
                productIndex = cartData.products.findIndex(function (product) {
                  return product.id === productId && product.size === variant;
                });

                if (!(productIndex < 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                cartData.products[productIndex].quantity = count;
                _context2.next = 7;
                return CartStorage/* default.saveCart */.Z.saveCart(cartData);

              case 7:
                _this.props.setCart(cartData);

                _this.setState({
                  refresh: !_this.state.refresh
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.state = {
      loading: false,
      refresh: false,
      pageHeight: 0,
      newBottom: false,
      isStockAvailable: false
    };
    return _this;
  }

  (0,createClass/* default */.Z)(Basket, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this._isBasketMounted = true;
      this.setState({
        pageHeight: window.innerHeight
      });
      window.addEventListener("resize", this.handleWindowResize, true);
      this.handleWindowResize();
      (0,helper/* getStockAvailability */.gb)(this.props.cartData.products).then(function (isStockAvailable) {
        if (_this2._isBasketMounted) {
          _this2.setState({
            isStockAvailable: isStockAvailable
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isBasketMounted = false;

      if (this.removeTimer) {
        clearTimeout(this.removeTimer);
      }

      window.removeEventListener("resize", this.handleWindowResize, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$store,
          _this$props$store2,
          _this$props$store3,
          _this3 = this;

      var _getPrice = (0,pricing_service/* getPrice */.a)({
        shippingCharge: (_this$props$store = this.props.store) === null || _this$props$store === void 0 ? void 0 : _this$props$store.shippingCharge
      }, this.props.cartData, null, null, (_this$props$store2 = this.props.store) === null || _this$props$store2 === void 0 ? void 0 : _this$props$store2.cohort),
          productTotalPrice = _getPrice.productTotalPrice,
          shippingFee = _getPrice.shippingFee;

      var price = (0,pricing_service/* truncateTo2Decimals */.w)(productTotalPrice - shippingFee);
      var isCheckoutDisabled = ((_this$props$store3 = this.props.store) === null || _this$props$store3 === void 0 ? void 0 : _this$props$store3.checkoutDisabled) || !this.props.cartData.products.length; // this.props.isProplanActive === false;

      return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
        className: "fixed top-0 z-[101] m-0 h-screen w-full max-w-app overflow-hidden bg-background text-fontBackground opacity-0 transition-all duration-500 ease-in-out ".concat(this.props.isBasketOpen ? "left-0 opacity-100" : "left-full"),
        children: [this.state.loading && /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex h-screen flex-col items-center overflow-y-auto p-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
            className: "relative m-0 w-full text-xl font-bold tracking-wider text-fontBackground",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "mr-3",
              children: "\uD83D\uDECD\uFE0F"
            }), " Your Bag", /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              className: "absolute right-0 z-50 inline-block border-none bg-transparent",
              onClick: function onClick() {
                return _this3.props.handleShowCart(!_this3.props.isBasketOpen);
              },
              "aria-label": "Close cart",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(io/* IoMdClose */.QAE, {
                size: 30,
                className: "text-primary"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-10 mb-[50px] w-full",
            children: react.Children.toArray(this.props.cartData.products.map(function (product) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Cart_BagItem, {
                item: product,
                removeProductFromCart: _this3.removeProductFromCart,
                updateProductCount: _this3.updateProductCount
              });
            }))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "h-[120px] w-full"
          })]
        }), this.props.isBasketOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "fixed bottom-0 left-1/2 w-full max-w-app -translate-x-1/2 transform bg-background px-3 py-4 text-fontBackground shadow-[0_-1px_4.5px_0_#ccc]",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
            className: "w-full rounded-2xl border-none bg-primary bg-none py-4 font-normal uppercase tracking-wider text-fontPrimary outline-none",
            style: {
              opacity: isCheckoutDisabled ? 0.2 : 1
            },
            disabled: isCheckoutDisabled,
            onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
              var _this3$props, _this3$props$store;

              var productsWithoutStore;
              return regenerator_default().wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      console.log("checkout click"); // Remove store property from products for tracking

                      productsWithoutStore = _this3.props.cartData.products.map(function (_ref4) {
                        var store = _ref4.store,
                            productWithoutStore = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded);

                        return productWithoutStore;
                      });
                      (0,analytics.trackEvent)(analyticsConfig.EVENTS.CHECKOUT_STARTED, {
                        subdomain: (_this3$props = _this3.props) === null || _this3$props === void 0 ? void 0 : (_this3$props$store = _this3$props.store) === null || _this3$props$store === void 0 ? void 0 : _this3$props$store.subdomain,
                        cart_data: productsWithoutStore
                      });
                      router_default().push("/cart/checkout");

                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })),
            children: ["Checkout \u2014 \u20B9", price]
          })
        }) : ""]
      });
    }
  }]);

  return Basket;
}(react.Component);



/***/ }),

/***/ 4834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_loader_spinner__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4162);
/* harmony import */ var react_loader_spinner_dist_loader_css_react_spinner_loader_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4501);
/* harmony import */ var react_loader_spinner_dist_loader_css_react_spinner_loader_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_loader_spinner_dist_loader_css_react_spinner_loader_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _AppContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1503);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2676);





var LoaderComponent = function LoaderComponent() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_AppContainer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "fixed inset-0 z-[95] flex items-center justify-center",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_loader_spinner__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        type: "Oval",
        color: "#ccc",
        height: 40,
        width: 40,
        timeout: 3000
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LoaderComponent);

/***/ }),

/***/ 1041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StoreItem; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/lottie-react@2.4.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/lottie-react/build/index.umd.js
var index_umd = __webpack_require__(1682);
var index_umd_default = /*#__PURE__*/__webpack_require__.n(index_umd);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/router.js
var next_router = __webpack_require__(6971);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(5271);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(2027);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-lazy-load-image-component@1.6.3_react@18.3.1/node_modules/react-lazy-load-image-component/src/effects/blur.css
var effects_blur = __webpack_require__(6035);
// EXTERNAL MODULE: ./contexts/StoreDataContext.js + 1 modules
var StoreDataContext = __webpack_require__(3104);
// EXTERNAL MODULE: ./lib/cdn.js
var cdn = __webpack_require__(8071);
// EXTERNAL MODULE: ./lib/media.js
var media = __webpack_require__(1008);
// EXTERNAL MODULE: ./services/frontend/pricing.service.js
var pricing_service = __webpack_require__(5049);
// EXTERNAL MODULE: ./services/helper.js + 23 modules
var helper = __webpack_require__(3236);
// EXTERNAL MODULE: ./store/search-store.js
var search_store = __webpack_require__(7019);
// EXTERNAL MODULE: ./components/Picture.jsx
var Picture = __webpack_require__(473);
;// CONCATENATED MODULE: ./components/shimmer.json
var shimmer_namespaceObject = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"Randy Varianda","k":"","d":"","tc":""},"fr":16,"ip":0,"op":32,"w":128,"h":128,"nm":"Lazy Load","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[-11.5,49,0],"to":[36.083,9.667,0],"ti":[-0.25,-0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.333,"y":0},"t":40,"s":[204.99999999999997,107,0],"to":[0.25,0.083,0],"ti":[35.833,9.583,0]},{"t":59,"s":[-10,49.5,0]}],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[179.208,93.896,100],"ix":6}},"ao":0,"ef":[{"ty":29,"nm":"Gaussian Blur","np":5,"mn":"ADBE Gaussian Blur 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Blurriness","mn":"ADBE Gaussian Blur 2-0001","ix":1,"v":{"a":0,"k":34.3,"ix":1}},{"ty":7,"nm":"Blur Dimensions","mn":"ADBE Gaussian Blur 2-0002","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"Repeat Edge Pixels","mn":"ADBE Gaussian Blur 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[7.721,144.227],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.7294117647058823,0.7490196078431373,0.8666666666666667,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-18.46,3.373],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,146.624],"ix":3},"r":{"a":0,"k":20.495,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[62.458000000000006,55.823,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[120.328,77.977],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":0,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0.9098039215686274,0.9176470588235294,0.9647058823529412,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1.542,8.177],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[109.644,176.784],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":40,"st":0,"bm":0}],"markers":[]}');
var components_shimmer_namespaceObject = /*#__PURE__*/__webpack_require__.t(shimmer_namespaceObject, 2);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2676);
;// CONCATENATED MODULE: ./components/StoreItem.jsx
// import dynamic from "next/dynamic";
// const Lottie = dynamic(() => import("lottie-react"), { ssr: false });












 // Browser-compatible path parsing





var parseFileName = function parseFileName(url) {
  if (!url) return "";
  var parts = url.split("/");
  var filename = parts[parts.length - 1].split("?")[0];
  return {
    name: filename.substring(0, filename.lastIndexOf(".")),
    ext: filename.substring(filename.lastIndexOf("."))
  };
};

var StoreItem = function StoreItem(_ref) {
  var _context$storeData, _context$storeData$st, _product$productPhoto;

  var usedForCollectionhome = _ref.usedForCollectionhome,
      product = _ref.product,
      cohort = _ref.cohort,
      toggleDrawer = _ref.toggleDrawer,
      search = _ref.search,
      customHeightWidth = _ref.customHeightWidth;
  var context = (0,StoreDataContext/* useStoreContext */.Q)();
  var lowStockThreshold = context === null || context === void 0 ? void 0 : (_context$storeData = context.storeData) === null || _context$storeData === void 0 ? void 0 : (_context$storeData$st = _context$storeData.storePrefs) === null || _context$storeData$st === void 0 ? void 0 : _context$storeData$st.lowStockThreshold;
  var showLowStockAlert = (0,helper/* checkProductOrActiveVariantHasLowStock */.PE)({
    product: product,
    lowStockThreshold: lowStockThreshold
  });

  var _useState = (0,react.useState)(false),
      imageLoaded = _useState[0],
      setImageLoaded = _useState[1];

  var _useState2 = (0,react.useState)(false),
      fallbackSet = _useState2[0],
      setFallbackSet = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      imageName = _useState3[0],
      setImageName = _useState3[1];

  var _useStore = (0,search_store/* default */.Z)(function (state) {
    return {
      setShouldSearchReopen: state.setShouldSearchReopen
    };
  }),
      setShouldSearchReopen = _useStore.setShouldSearchReopen;

  var router = (0,next_router.useRouter)();

  var getProductPrice = function getProductPrice(price) {
    var mrp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    if (!price) return;

    if (mrp) {
      var truncatedMrp = (0,pricing_service/* truncateTo2Decimals */.w)(mrp);

      var strikeOutMRP = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-sm font-light line-through opacity-60",
        children: "".concat(String.fromCharCode(0x20b9)).concat(truncatedMrp)
      });

      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["".concat(String.fromCharCode(0x20b9)).concat(price), " ", strikeOutMRP]
      });
    } else {
      return "".concat(String.fromCharCode(0x20b9)).concat(product.price);
    }
  }; // media pipeline: compressed variants when a ready V2 entry exists (flag-gated), else today's URL


  var resolved = (0,media/* resolveImage */.rs)(product === null || product === void 0 ? void 0 : (_product$productPhoto = product.productPhotos) === null || _product$productPhoto === void 0 ? void 0 : _product$productPhoto[0], product === null || product === void 0 ? void 0 : product.productPhotosV2, usedForCollectionhome ? "gridWide" : "grid");

  var getImageUrl = function getImageUrl() {
    if (!imageName) return "";
    var imageurl = "";

    if (product.productPhotos && product.productPhotos[0]) {
      if (product.productPhotos[0].includes("dm2buy")) {
        imageurl = "https://dm2buy-resize-dynamic-cebdcaefgydgh6hu.z02.azurefd.net/dm2buy/".concat(imageName, ".jpg?width=400&height=400");
      } else {
        imageurl = (0,cdn/* toCdnUrl */.V$)(product.productPhotos[0]);
      }
    }

    return imageurl;
  };

  (0,react.useEffect)(function () {
    var urlPath = product.productPhotos && product.productPhotos[0] ? // eslint-disable-next-line no-undef
    new URL(product.productPhotos[0]).pathname : "";
    var extractedImageName = parseFileName(urlPath).name;
    setImageName(extractedImageName);
  }, [product.productPhotos]);

  var checkStock = function checkStock() {
    var stockAvailable = false;

    if (product.variantOptions && product.variantOptions.length) {
      product.variantOptions.forEach(function (variant) {
        if ((variant === null || variant === void 0 ? void 0 : variant.availableStock) > 0) {
          stockAvailable = true;
        }
      });
    } else {
      return product.availableStock;
    }

    return stockAvailable;
  }; // Calculate dynamic widths based on collection home usage


  var imageWidthClass = usedForCollectionhome ? "w-[calc((var(--max-width)/1.5)-50px)] h-[calc((var(--max-width)/1.5)-50px)]" : "w-[calc((100vw/2)-33px)] h-[calc((100vw/2)-33px)] md:w-[calc((520px/2)-33px)] md:h-[calc((520px/2)-33px)]";
  var itemWidthClass = usedForCollectionhome ? "max-w-[calc((var(--max-width)/1.5)-50px)] mb-3" : "max-w-[calc((100vw/2)-33px)] mb-8 md:max-w-[calc((520px/2)-33px)]";
  if (!product) return "";
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    href: "/product/".concat(product.id),
    className: "flex flex-col items-start justify-start ".concat(itemWidthClass),
    onClick: function onClick() {
      if (search) {
        setShouldSearchReopen(router.asPath);
      } else {
        setShouldSearchReopen(null);
      }

      router.push("/product/".concat(product.id));

      if (toggleDrawer) {
        toggleDrawer();
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: product && (product === null || product === void 0 ? void 0 : product.productPhotos[0]) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative rounded-lg",
          children: [!checkStock(product) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute z-10 flex h-[98%] w-full cursor-pointer items-center justify-center rounded-lg text-2xl font-bold text-[#ff3333]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "m-0 p-0 tracking-[3px]",
              children: "SOLD"
            })
          }), showLowStockAlert && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-1.5 top-1.5 z-10 flex rounded-md bg-primary text-xs text-fontPrimary",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "p-1.5",
              children: "Only few left!"
            })
          }), showLowStockAlert && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute left-1.5 top-1.5 z-10 flex rounded-md bg-primary text-xs text-fontPrimary",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "p-1.5",
              children: "Only few left!"
            })
          }), !imageLoaded && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "rounded-lg ".concat(customHeightWidth ? customHeightWidth : imageWidthClass),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((index_umd_default()), {
              className: "rounded-lg border " + (customHeightWidth && "h-full"),
              animationData: shimmer_namespaceObject || components_shimmer_namespaceObject,
              loop: true,
              autoplay: true,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
              }
            })
          }), resolved.isV2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, {
            resolved: resolved,
            alt: product.name,
            style: !imageLoaded ? {
              visibility: "hidden",
              height: "0px !important",
              width: "0px !important",
              zIndex: 1,
              position: "absolute"
            } : {
              cursor: "pointer"
            },
            imgClassName: "rounded-lg object-cover ".concat(customHeightWidth ? customHeightWidth : imageWidthClass, " max-w-[none]"),
            onLoad: function onLoad() {
              setImageLoaded(true);
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(build.LazyLoadImage, {
            style: !imageLoaded ? {
              visibility: "hidden",
              height: "0px !important",
              width: "0px !important",
              zIndex: 1,
              position: "absolute"
            } : {
              cursor: "pointer"
            },
            onLoad: function onLoad() {
              setImageLoaded(true);
            },
            onError: function onError(e) {
              if (!fallbackSet) {
                // Handle image load error by setting a fallback URL
                e.target.src = "".concat(product === null || product === void 0 ? void 0 : product.productPhotos[0]);
                setFallbackSet(true);
              }
            },
            className: "rounded-lg object-cover ".concat(customHeightWidth ? customHeightWidth : imageWidthClass, " max-w-[none]"),
            src: getImageUrl(imageName, cohort),
            unoptimized: "true",
            objectfit: "cover",
            alt: product.name,
            effect: customHeightWidth ? "blur" : undefined
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex w-full flex-col py-1",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mb-1 cursor-pointer text-wrap text-base font-normal text-fontBackground opacity-70",
          children: product && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "line-clamp-1",
            children: product.name
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "cursor-pointer text-base font-bold text-fontBackground",
          children: product && getProductPrice(product.price, product.mrp)
        })]
      })]
    })
  });
};

/* harmony default export */ var components_StoreItem = (StoreItem);

/***/ }),

/***/ 5049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getPrice; },
/* harmony export */   "w": function() { return /* binding */ truncateTo2Decimals; }
/* harmony export */ });
/* harmony import */ var _utils_order_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2009);
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var serviceChargeMapping = {
  cc: function cc(deliveryOption) {
    return deliveryOption && deliveryOption.key === "international" ? 4.99 : 3.03;
  },
  dc: function dc(price, deliveryOption) {
    return deliveryOption && deliveryOption.key === "international" ? 4.99 : price > 2000 ? 2.28 : 2.0;
  },
  upi: function upi(price, cohort) {
    var hasCohort5 = cohort && Array.isArray(cohort) && cohort.includes(5);
    return price > 600 ? hasCohort5 ? 2.0 : 1.75 : 2.18;
  },
  app: 2.98,
  nb: 2.93,
  bnpl: 5.0
};

var truncateTo2Decimals = function truncateTo2Decimals(num) {
  if (num == null) return null;
  return Math.floor(num * 100) / 100;
};

var getApplicableProcessingFee = function getApplicableProcessingFee(processingFee, processingFeePayee) {
  if (!processingFeePayee) {
    return processingFee;
  } else if (processingFeePayee !== "self") {
    return processingFee;
  }

  return 0;
};

var getPrice = function getPrice(deliveryOption, cart) {
  var paymentMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var processingFeePayee = arguments.length > 3 ? arguments[3] : undefined;
  var cohort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var partialPaymentPercentage = deliveryOption.partialPaymentPercentage;
  var calculatedPrice = 0;
  var shippingFeeApplied = false;
  var shippingFee = deliveryOption.shippingCharge;
  var discountedAmount = cart === null || cart === void 0 ? void 0 : cart.discountedAmount;
  var couponId, couponCode;
  var partialPaymentPrice = null;

  if (discountedAmount) {
    couponId = cart.couponId;
    couponCode = cart.couponCode;
  }

  var actualShippingFee = cart.shippingFee;
  var shippingFeeCap = Number.isInteger(cart.shippingFeeCap) ? cart.shippingFeeCap : Number.MAX_SAFE_INTEGER;

  var _iterator = _createForOfIteratorHelper(cart.products),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var product = _step.value;
      var productQuantity = product.quantity ? product.quantity : 1;
      calculatedPrice += product.price * productQuantity;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var priceWithoutFees = calculatedPrice;

  if (discountedAmount) {
    calculatedPrice = priceWithoutFees - discountedAmount;
  }

  if (calculatedPrice < shippingFeeCap) {
    calculatedPrice += shippingFee ? shippingFee : 0;
    shippingFeeApplied = true;
  } else {
    shippingFee = 0;
  }

  var productTotalPrice = calculatedPrice;
  var processingFee = 0;

  if ((0,_utils_order_util__WEBPACK_IMPORTED_MODULE_0__/* .isCODWithoutPartialPayment */ .D)(deliveryOption)) {
    processingFee = 0;
  } else if (paymentMode === "dc") {
    processingFee = Number((calculatedPrice * (serviceChargeMapping[paymentMode](calculatedPrice, deliveryOption) / 100)).toFixed(2));
  } else if (paymentMode === "cc") {
    processingFee = Number((calculatedPrice * (serviceChargeMapping[paymentMode](deliveryOption) / 100)).toFixed(2));
  } else if (paymentMode) {
    var serviceCharge = serviceChargeMapping[paymentMode];

    if (typeof serviceCharge === "function") {
      // For UPI, pass cohort as second parameter; for other payment modes, pass appropriate parameters
      if (paymentMode === "upi") {
        processingFee = Number((calculatedPrice * (serviceCharge(calculatedPrice, cohort) / 100)).toFixed(2));
      } else {
        processingFee = Number((calculatedPrice * (serviceCharge(calculatedPrice) / 100)).toFixed(2));
      }
    } else {
      // Handle cases where serviceCharge is a number (like app, nb)
      processingFee = Number((calculatedPrice * (serviceCharge / 100)).toFixed(2));
    }
  } else {
    processingFee = Number((calculatedPrice * 0.02).toFixed(2));
  }

  processingFee++;
  var pricewithShipping = calculatedPrice;
  calculatedPrice += getApplicableProcessingFee(processingFee, processingFeePayee);

  if (partialPaymentPercentage) {
    partialPaymentPrice = pricewithShipping * (partialPaymentPercentage / 100) + getApplicableProcessingFee(processingFee, processingFeePayee);
  }

  calculatedPrice = calculatedPrice != 0 ? calculatedPrice.toFixed(2) : calculatedPrice;
  return {
    productTotalPrice: productTotalPrice,
    total: calculatedPrice,
    shippingFee: shippingFee,
    shippingFeeCap: shippingFeeCap,
    actualShippingFee: actualShippingFee,
    paymentProcessingFee: processingFee,
    shippingFeeApplied: shippingFeeApplied,
    priceWithoutFees: priceWithoutFees,
    couponId: couponId,
    couponCode: couponCode,
    partialPaymentPrice: partialPaymentPrice
  };
};



/***/ }),

/***/ 2009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ isCODWithoutPartialPayment; }
/* harmony export */ });
var isCODWithoutPartialPayment = function isCODWithoutPartialPayment(deliveryOption) {
  return deliveryOption.key === "cod" && deliveryOption.partialPaymentPercentage === undefined;
};

/***/ }),

/***/ 1257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"orderItem":"bag-item_orderItem__qfNaV","productDetails":"bag-item_productDetails__CtRZY","thumbnailContainer":"bag-item_thumbnailContainer__MPJwK","orderThumbnail":"bag-item_orderThumbnail__zsTVG","productColor":"bag-item_productColor__FiiNG","productName":"bag-item_productName__VGY2z","quantityControls":"bag-item_quantityControls__gY_Jn","product_specs":"bag-item_product_specs__oC3OI","details_right":"bag-item_details_right__Q3sLu","productPrice":"bag-item_productPrice__SIffP","attachmentLink":"bag-item_attachmentLink__lY3Jm","fileName":"bag-item_fileName__eFy8x"};

/***/ })

}]);